webpackJsonp([242216996668485],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _digitalRealities = __webpack_require__(21);
	
	var _digitalRealities2 = _interopRequireDefault(_digitalRealities);
	
	var _SlideshowFooter = __webpack_require__(8);
	
	var _SlideshowFooter2 = _interopRequireDefault(_SlideshowFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prev = '/digital-realities/ar_colony-square';
	var next = '/digital-realities/vr_250-williams';
	
	var sliderImages = _digitalRealities2.default[1].slideshow.map(function (img, idx) {
	    return _react2.default.createElement(
	        'div',
	        { key: 'image-' + idx },
	        _react2.default.createElement('img', { src: img, alt: '' })
	    );
	});
	
	var DigitalRealities = function DigitalRealities(props) {
	    return _react2.default.createElement(
	        'div',
	        { id: 'digital-reality-landing' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'IMBIBE - Digital Realities: What is Virtual Reality?'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'What is Virtual Reality?' })
	        ),
	        _react2.default.createElement('img', { src: 'http://dev.imbibe.info/images/ar_what-is-ar/hero.jpg' }),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'What is AR?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Officially, Augmented Reality is \u201Ca technology that superimposes a computer-generated image on a user\'s view of the real world, thus providing a composite view.\u201D'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Unlike Virtual Reality, where you are placed in an entirely new environment, augmented reality allows a user to still see and interact with the world around them, but with the addition of supplemental content (images and data).'
	                    )
	                ),
	                sliderImages
	            )
	        ),
	        _react2.default.createElement(_SlideshowFooter2.default, { vr: true, prev: prev, next: next })
	    );
	};
	
	exports.default = DigitalRealities;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digital-realities-what-is-ar-js-041b32b561bd33764322.js